import { getShifts } from "../member/memberSelectors";
import { fetchShifts } from "../member/memberActions";
import { RequestError, sendJSON } from "../../utils/request";
import { clearAlerts, showAlert } from "../../utils/flash";
import i18n from "../../utils/i18n";

export const updateStartDate = (start_date) => ({
  type: "SCHEDULE_UPDATE_START_DATE",
  payload: start_date,
});

export const updateNumberOfDays = (number_of_days) => ({
  type: "SCHEDULE_UPDATE_NUMBER_OF_DAYS",
  payload: number_of_days,
});

export const setLoading = (loading) => ({
  type: "SCHEDULE_SET_LOADING",
  payload: loading,
});

export const setShifts = (shifts) => ({
  type: "SCHEDULE_SET_SHIFTS",
  payload: shifts,
});

export const setSaveStatus = (status) => ({
  type: "SCHEDULE_SET_SAVE_STATUS",
  payload: status,
});

// A 422 carries the form's validation messages (#1087). Anything else - a 500, a lost connection -
// has nothing the user can act on beyond knowing the save did not happen.
const saveErrorMessage = async (error) => {
  if (error instanceof RequestError && error.status === 422) {
    try {
      const { errors } = await error.response.json();
      if (errors?.length) return errors.join(" ");
    } catch {
      // Not the JSON body the controller sends; fall through to the generic message.
    }
  }

  return i18n.t("schedule.save_failed");
};

export const saveSchedule = (url, publish) => {
  return (dispatch, getState) => {
    const state = getState();

    dispatch(setSaveStatus("saving"));

    return sendJSON(url, {
      method: "PUT",
      headers: { Accept: "application/json" },
      body: {
        schedule: {
          shifts: getShifts(state),
          publish: publish,
          force: true,
        },
      },
    })
      .then(() => {
        window.exitWarningDirty = false;
        // Reload before reporting success, not after. The check mark is what tells the user - and
        // what tells a system spec - that the save is done, so it has to mean the whole of it: the
        // reload used to be dispatched after the indicator was already up, which left the request
        // in flight with nothing waiting for it (#984), and showed a saved schedule that had not
        // been refreshed from the server yet. fetchShifts handles its own failures, so a reload
        // that does not come back cannot turn a save that succeeded into an error.
        return dispatch(fetchShifts('shifts.json'));
      })
      .then(() => {
        clearAlerts();
        dispatch(setSaveStatus("success"));
        setTimeout(() => {dispatch(setSaveStatus(false))}, 800);
      })
      .catch(async (error) => {
        showAlert(await saveErrorMessage(error));
        dispatch(setSaveStatus("error"));
        // Back to the Save link, or a rejected save could only be retried by reloading the page,
        // which throws away the edits it was trying to save.
        setTimeout(() => {dispatch(setSaveStatus(false))}, 2000);
      });
  };
};
